<script>
	// import crypto from "crypto";

	import request from "./request.vue";
	import { format } from "date-fns";

	const schema = [
		{
			name: "id",
			displayName: "Código",
			kind: "text",
			validation: "",
			placeholder: "Digite o código do chat",
			readOnly: true,
			notInFilters: true,
			search: {
				show: true,
			},
		},
		{
			name: "creationDate",
			displayName: "Data do cadastro",
			kind: "text",
			validation: "",
			placeholder: "",
			readOnly: true,
			formatter: value => format(value, "DD/MM/YYYY HH:mm"),
			creationHidden: true,
			notInFilters: true,
			search: {
				show: true,
			},
		},
		{
			name: "userName",
			displayName: "Nome do usuário",
			kind: "text",
			validation: "",
			placeholder: "",
			readOnly: true,
			notInFilters: false,
			creationHidden: true,
			search: {
				show: true,
			},
		},
		{
			name: "status",
			displayName: "Status",
			kind: "text",
			validation: "",
			placeholder: "",
			notInFilters: true,
			readOnly: true,
			formatter: value => {
				const options = {
					RESPONDED: "Respondida",
					PENDING: "Pendente",
				};

				return options[value];
			},
			creationHidden: true,
			defaultSort: true,
			search: {
				show: true,
			},
		},
		{
			name: "lastMessage",
			displayName: "Última mensagem",
			kind: "text",
			validation: "",
			placeholder: "",
			readOnly: true,
			notInFilters: true,
			formatter: value => value ? format(value, "DD/MM/YYYY HH:mm") : "Não enviada",
			creationHidden: true,
			search: {
				show: true,
			},
		},
	];

	export default {
		getInfo: async function (userId) {
			const response = await request.send("chat", "getChannel", { userId }, true);
			return response.data;
		},
		remove: async function (id) {
			return request.send("user", "delete", { id }, true);
		},
		search: async function(parameters) {
			const response = await request.send("chat", "listChannels", parameters, true);
			return response;
		},
		getToken: async function() {
			const response = await request.send("chat", "getTwilioAccessToken", {}, true);
			return response.data.twilioAccessToken;
		},
		getSchema: function() {
			return schema;
		},
	}
</script>
